import React from 'react';
import { Alert, ModalBody, ModalFooter, CompassColor, ModalContent, ModalHeader, } from '@noom/wax-component-library';
import { FormattedMessage } from 'react-intl';
import Button, { PrimaryButton, ButtonGroup } from '../../../../core/components/Button';
export function ErrorView({ isLoading, onReset, onCancel }) {
    return (React.createElement(ModalContent, { bg: CompassColor.offWhite },
        React.createElement(ModalHeader, null,
            React.createElement(FormattedMessage, { id: "onboarding.error.title" })),
        React.createElement(ModalBody, null,
            React.createElement(Alert, { status: "error" },
                React.createElement(FormattedMessage, { id: "onboarding.error.message" }))),
        React.createElement(ModalFooter, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { isLoading: isLoading, onClick: onCancel },
                    React.createElement(FormattedMessage, { id: "onboarding.error.cancel" })),
                React.createElement(PrimaryButton, { isLoading: isLoading, onClick: onReset },
                    React.createElement(FormattedMessage, { id: "onboarding.error.reset" }))))));
}
//# sourceMappingURL=ErrorView.js.map